module.exports = __webpack_public_path__ + "img/zlindex11.8c7ab673.png";